import {request} from "../request/request";

const scoreCriterion = {
  getTypes: () => request.read('/score-criterion/type', null, true),
};

export {scoreCriterion};
